import AccountCreation from '@/components/AccountCreation';
import AccountSuspended from '@/components/AccountSuspended';
import UpcomingTransactionsForInvestor from '@/components/UpcomingTransactionsForInvestor';
import EditUserProfile from '@/components/EditUserProfile';
import EditUserProfileByAdvisor from '@/components/EditUserProfileByAdvisor';
import InvestorPreferences from '@/components/InvestorPreferences';
import Registration from '@/components/Registration';
import Login from '@/components/Login';
import Home from '@/components/Home';
import ResetPassword from '@/components/ResetPassword';
import ChangePassword from '@/components/ChangePassword';
import VerifyEmail from '@/components/VerifyEmail';
import AddFundingSource from '@/components/AddFundingSource';
import PurchaseNote from '@/components/PurchaseNote';
import NotesList from '@/components/NotesList';
import MicroDepositsVerification from '@/components/MicroDepositsVerification';
import KbaVerification from '@/components/KbaVerification';
import AccountSummary from '@/components/AccountSummary';
import DocumentUpload from '@/components/DocumentUpload';
import AccountDocuments from '@/components/AccountDocuments';
import InvestorAccountDetails from '@/components/InvestorAccountDetails';
import ErrorAuth from '@/components/ErrorAuth';
import InvestorCommunicationPreferences from '@/components/InvestorCommunicationPreferences';
import InvestorPaymentPreferences from '@/components/InvestorPaymentPreferences';
import EmbedLogin from '@/components/EmbedLogin';
import FeedbackSurvey from '@/components/FeedbackSurvey';

export default [
  {
    path: '/embed-login',
    name: 'EmbedLogin',
    component: EmbedLogin,
  },
  {
    path: '/',
    name: 'Registration',
    component: Registration,
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword,
  },
  {
    path: '/verify-email',
    name: 'VerifyEmail',
    component: VerifyEmail,
  },
  {
    path: '/account-summary',
    name: 'AccountSummary',
    component: AccountSummary,
  },
  {
    path: '/account-creation',
    name: 'AccountCreation',
    component: AccountCreation,
  },
  {
    path: '/upcoming-transactions',
    name: 'UpcomingTransactionsForInvestor',
    component: UpcomingTransactionsForInvestor,
  },
  {
    path: '/funding-sources',
    name: 'AddFundingSource',
    component: AddFundingSource,
  },
  {
    path: '/funding-sources/:id/micro-deposits',
    name: 'MicroDepositsVerification',
    component: MicroDepositsVerification,
  },
  {
    path: '/kba',
    name: 'KbaVerification',
    component: KbaVerification,
  },
  {
    path: '/notes/purchase',
    name: 'PurchaseNote',
    component: PurchaseNote,
  },
  {
    path: '/notes',
    name: 'Notes',
    component: NotesList,
  },
  {
    path: '/investor-impact-preferences',
    name: 'InvestorPreferences',
    component: InvestorPreferences,
  },
  {
    path: '/account-suspended',
    name: 'AccountSuspended',
    component: AccountSuspended,
  },
  {
    path: '/edit-user-profile',
    name: 'EditUserProfile',
    component: EditUserProfile,
  },
  {
    path: '/edit-user-profile-by-advisor',
    name: 'EditUserProfileByAdvisor',
    component: EditUserProfileByAdvisor,
  },
  {
    path: '/documents',
    name: 'DocumentUpload',
    component: DocumentUpload,
  },
  {
    path: '/account-documents',
    name: 'AccountDocuments',
    component: AccountDocuments,
  },
  {
    path: '/accounts/:id/details',
    name: 'InvestorAccountDetails',
    component: InvestorAccountDetails,
  },
  {
    path: '/error',
    name: 'ErrorAuth',
    component: ErrorAuth,
  },
  {
    path: '/investor-communication-preferences',
    name: 'InvestorCommunicationPreferences',
    component: InvestorCommunicationPreferences,
  },
  {
    path: '/investor-payment-preferences',
    name: 'InvestorPaymentPreferences',
    component: InvestorPaymentPreferences,
  },
  {
    path: '/feedback',
    name: 'FeedbackSurvey',
    component: FeedbackSurvey,
  },
];



// WEBPACK FOOTER //
// ./src/router/investor.js